var React = require('react');

function HomeTopWaveInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.1","d":"M1437.13 142.025C1227.2 119.663 1174.59 245.234 1015.93 278.815C826.358 318.977 658.417 235.586 508.737 278.815C362.873 320.921 214.914 473.491 -1 411.267V0H1439L1437.13 142.025Z","fill":"white"}));
}

HomeTopWaveInline.defaultProps = {"width":"1439","height":"426","viewBox":"0 0 1439 426","fill":"none"};

module.exports = HomeTopWaveInline;

HomeTopWaveInline.default = HomeTopWaveInline;
